import { ICategory, IGroupInfo } from '../../typings/model/group';
import { ChannelBaseInfo, GroupInfo, SPECIAL_ROLE_ID } from '../../typings/proto';

export function isCmdChannel(channel: ChannelBaseInfo): boolean {
  return channel.isCmdChan !== 0;
}

export function isGroupChannel(groupInfo: IGroupInfo, channelId: string): boolean {
  return groupInfo.channelIdList.indexOf(channelId) !== -1;
}

export function isGroupCmdChannel(groupInfo: IGroupInfo, channelId: string): boolean {
  return groupInfo.cmdChannelIdList.indexOf(channelId) !== -1;
}

export function isGroupAdmin(roleIdList: string[]): boolean {
  return roleIdList.includes(SPECIAL_ROLE_ID.ID_GROUP_OWNER.toString())
  || roleIdList.includes(SPECIAL_ROLE_ID.ID_ADMIN.toString());
}

export function isGroupOwner(roleIdList: string[]): boolean {
  return roleIdList.includes(SPECIAL_ROLE_ID.ID_GROUP_OWNER.toString());
}

export function getFormatGroupInfo(data: GroupInfo): IGroupInfo {
  const cateList: Array<ICategory> = [{ caid: '0', name: '', channelList: [], isFold: false }];
  const cateChan: Record<string, ChannelBaseInfo[]> = {};
  const channelIdList: Array<string> = [];
  const cmdChannelIdList: Array<string> = [];
  const result: IGroupInfo = Object.assign({ cateList: [], channelIdList: [], cmdChannelIdList: [] }, data);
  if (data?.chanList?.length) {
    data.chanList.forEach((channel) => {
      const isCmd = isCmdChannel(channel);
      if (channel?.caid && !isCmd) {
        cateChan[channel?.caid] = cateChan[channel?.caid] || [];
        cateChan[channel?.caid].push(channel);
      }
      if (!isCmd) {
        channelIdList.push(channel.cid);
      } else {
        cmdChannelIdList.push(channel.cid);
      }
    });
  }
  if (data?.info?.cateList?.length) {
    data.info.cateList.forEach((cate) => {
      cateList.push(Object.assign({ channelList: [] }, cate));
    });
  }

  cateList.forEach((cate) => {
    // eslint-disable-next-line no-param-reassign
    cate.channelList = cateChan[cate?.caid] ?? [];
  });

  result.cateList = cateList;
  result.channelIdList = channelIdList;
  result.cmdChannelIdList = cmdChannelIdList;
  if (data?.info?.welInfo) {
    result.welInfo = data.info.welInfo;
  }
  return result;
}
